var path = '/var/www/mmscny-cms/src/app/common/components/select-dropdown/select-dropdown.html';
var html = "<div class=form-padding> <div class=form-group> <label for=year>{{$ctrl.labelText ? $ctrl.labelText + '*' : ''}}</label> <div class=select-wrapper> <select class=\"form-control select-wrapper\" id=year ng-model=$ctrl.selectedId ng-options=\"item.id as item.name for item in $ctrl.list\" ng-change=\"$ctrl.onChange({$event: $ctrl.selectedId})\" required> <option value=\"\" ng-disabled=$ctrl.isDisabled ng-if=$ctrl.defaultOption>{{$ctrl.defaultOption}}</option> </select> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/select-dropdown/select-dropdown.html
// module id = 743
// module chunks = 0